import React, { FC } from 'react'
import { cn } from 'src/slides/lib/utils'
import { Input, InputSizes } from 'src/components/ui/Input'

export interface IHeaderSearchProps {
  value?: string
  onChange?: (value: string) => void
  placeholder?: string
  variant?: 'desktop' | 'mobile'
  className?: string
  autoFocus?: boolean
}

export const HeaderSearch: FC<IHeaderSearchProps> = ({
  value = '',
  onChange,
  placeholder = 'Search...',
  variant = 'desktop',
  className,
  autoFocus,
}) => {
  const isMobile = variant === 'mobile'

  return (
    <div
      className={cn(
        isMobile
          ? 'relative w-full'
          : 'relative flex-1 max-w-sm md:max-w-md ml-auto mr-4',
        className
      )}
    >
      <Input
        size={InputSizes.large}
        type="search"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        autoFocus={autoFocus}
        isClearable
        onClear={() => onChange?.('')}
        leftIcon={
          <svg
            className="w-4 h-4 pointer-events-none"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        }
        aria-label={placeholder}
      />
    </div>
  )
}

export default HeaderSearch
